module.exports = __webpack_public_path__ + "img/sl.2277fd3c.jpg";